var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const compare = () => ({
  windowWidth: window.innerWidth,
  products: [],
  prevSelectedSlugs: {},
  selectedSlugs: {},
  selectedProducts: {},
  get selectKeys() {
    const maxCount = this.windowWidth > 1068 ? 5 : this.windowWidth > 734 ? 3 : 2;
    const selectCount = Math.min(maxCount, this.products.length);
    return ["first", "second", "third", "fourth", "fifth"].slice(0, selectCount);
  },
  get optionGroups() {
    const optionGroups = [...new Set(this.products.map((product) => product.option_group))];
    const optionGroupsWithOptions = optionGroups.map((group) => ({
      label: group,
      products: this.products.filter((product) => product.option_group === group)
    }));
    return optionGroupsWithOptions;
  },
  setProducts() {
    var _a;
    const products = JSON.parse(((_a = this.$refs.compareData) == null ? void 0 : _a.innerText) || "[]");
    this.products = products.map((product) => {
      const colors = [];
      for (let index = 1; index <= 8; index++) {
        const key = `color_${index}`;
        if (product[key]) {
          colors.push(product[key]);
        }
      }
      return __spreadProps(__spreadValues({}, product), {
        colors,
        features: product.features.map((feature, index) => {
          const withImage = products.some((p) => p.features[index].image);
          const withText = products.some((p) => p.features[index].text);
          const withTopText = products.some((p) => p.features[index].text_top);
          const empty = !withImage && !withText && !withTopText;
          return __spreadProps(__spreadValues({}, feature), {
            withImage,
            withText,
            withTopText,
            empty
          });
        })
      });
    });
  },
  featureHasImage(index) {
    return Boolean(this.products.find((product) => product.features[index].image));
  },
  getFeatureText(index, key, type = "text") {
    const text = this.selectedProducts[key].features[index][type];
    if (!text)
      return "";
    return text.replaceAll("<br />\n<br />", '<div class="compare__feature-text-space"> </div>');
  },
  setSelectedSlugs() {
    const selectedSlugs = {};
    this.selectKeys.forEach((key, index) => {
      selectedSlugs[key] = this.products[index].slug;
    });
    this.selectedSlugs = selectedSlugs;
  },
  checkSelectedSlugs() {
    const prevEntries = Object.entries(this.prevSelectedSlugs);
    if (!prevEntries.length)
      return;
    const changedKey = this.getChangedKey();
    for (const key in this.selectedSlugs) {
      if (key === changedKey)
        continue;
      const isDuplicate = this.selectedSlugs[key] === this.selectedSlugs[changedKey];
      if (isDuplicate) {
        this.selectedSlugs[key] = this.prevSelectedSlugs[changedKey];
      }
    }
  },
  getChangedKey() {
    for (const key in this.selectedSlugs) {
      if (this.selectedSlugs[key] !== this.prevSelectedSlugs[key]) {
        return key;
      }
    }
  },
  setPrevSelectedSlugs() {
    const prevSelectedSlugs = {};
    for (const [key, value] of Object.entries(this.selectedSlugs)) {
      prevSelectedSlugs[key] = value;
    }
    this.prevSelectedSlugs = prevSelectedSlugs;
  },
  setSelectedProducts() {
    const selectedProducts = {};
    for (const key in this.selectedSlugs) {
      const product = this.products.find((p) => p.slug === this.selectedSlugs[key]);
      selectedProducts[key] = __spreadProps(__spreadValues({}, product), { key });
    }
    this.selectedProducts = selectedProducts;
  },
  init() {
    this.$watch("products", () => {
      this.setSelectedSlugs();
    });
    this.$watch("selectedSlugs", () => {
      this.checkSelectedSlugs();
      this.setPrevSelectedSlugs();
      this.setSelectedProducts();
    });
    this.$watch("selectKeys", () => {
      this.setSelectedSlugs();
    });
    this.setProducts();
  }
});
window.Alpine.data("compare", compare);
window.Alpine.start();
